/**
 * PostHog Analytics Wrapper
 * No-ops gracefully when REACT_APP_POSTHOG_KEY is missing (safe for local dev).
 */
import posthog from 'posthog-js';

// Typed event names to prevent typos
export const EVENTS = {
  PRODUCT_VIEWED: 'product_viewed',
  ADDED_TO_CART: 'added_to_cart',
  CHECKOUT_STARTED: 'checkout_started',
  PURCHASE_COMPLETED: 'purchase_completed',
} as const;

type EventName = (typeof EVENTS)[keyof typeof EVENTS] | string;

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

function isEnabled(): boolean {
  return !!KEY;
}

const analytics = {
  init() {
    if (!isEnabled()) return;
    posthog.init(KEY!, {
      api_host: HOST,
      autocapture: true,
      capture_pageview: false, // we fire manually for SPA
      persistence: 'localStorage',
    });
  },

  identify(distinctId: string, properties?: Record<string, any>) {
    if (!isEnabled()) return;
    posthog.identify(distinctId, properties);
  },

  track(event: EventName, properties?: Record<string, any>) {
    if (!isEnabled()) return;
    posthog.capture(event, properties);
  },

  pageview(url?: string) {
    if (!isEnabled()) return;
    posthog.capture('$pageview', url ? { $current_url: url } : undefined);
  },

  reset() {
    if (!isEnabled()) return;
    posthog.reset();
  },

  group(type: string, id: string, properties?: Record<string, any>) {
    if (!isEnabled()) return;
    posthog.group(type, id, properties);
  },
};

export default analytics;
